import { Component } from '../core/smpl-components'
import { ExpandableElement } from '../modules/expandable-element'
import { ResizeCallback } from '../utils/resize-callback'

// -----------------------------------------------------------------------------
// Archive list.
//
// Each `.archive-row` has a `.archive-row__body` clipped to a fixed height in
// CSS. Clicking the row expands the body to its natural height and back, driven
// by ExpandableElement (measureMode 'class': it lifts the CSS height restriction
// to measure, then animates). The `.is-expanded` class keeps the body open once
// the animation settles (see _objects/_archive-list.scss), and `.is-expandable`
// gates the hover-scale affordance so only rows with hidden overflow invite a
// click. Collapsed height is rem-based, so we refresh on resize to re-measure.
// Selector: `.js-archive-list` (see setup/components.js).
// -----------------------------------------------------------------------------
export default class extends Component {
	prepare() {
		this.expandables = [...this.element.querySelectorAll('.archive-row')].map(
			(row) =>
				new ExpandableElement({
					element: row,
					toggleElement: row,
					wrapperSelector: '.archive-row__body',
					contentSelector: '.archive-row__body__inner',
					measureMode: 'class',
					ease: 'power2.out',
					animationDuration: 0.2,
				}),
		)
	}

	mount() {
		this.resizeCallback = new ResizeCallback(() => this.refresh())
	}

	refresh() {
		this.expandables.forEach((expandable) => expandable.refresh())
	}

	unmount() {
		this.resizeCallback?.destroy()
		this.expandables.forEach((expandable) => expandable.destroy())
		this.expandables = []
	}
}
